import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {Experience} from '@wix/ambassador-table-reservations-v1-experience/types'
import {ReservationLocation} from '@wix/ambassador-table-reservations-v1-reservation-location/types'
import {
  IWidgetControllerConfig,
  SiteStructure,
} from '@wix/native-components-infra/dist/src/types/types'
import {BreadcrumbsItem} from 'wix-ui-tpa/dist/cssVars/types/components'

import {noop} from '../../utils/helpers'
import {AppPage} from '../../utils/constants'
import {goToExperienceDetails} from '../../utils/navigation'
import {createStorageProvider} from '../../utils/storageContext'
import {RequestStatus, wrapRequest} from '../../utils/wrapRequest'
import {experiencesService} from '../../services/experiencesService'
import {getBreadcrumbsConfig} from '../../utils/getBreadcrumbsConfig'
import {reservationLocationsService} from '../../services/reservationLocationsService'
import {getRegionalSettings} from '../../utils/flowAPI'

interface ExperiencesListData {
  getReservationLocationsStatus: RequestStatus
  getExperiencesStatus: RequestStatus
  breadcrumbsConfig: BreadcrumbsItem[]
  regionalSettings?: string
  reservationLocations: ReservationLocation[]
  experiences: Experience[]
  fitToContentHeight: boolean
}

interface ExperiencesListActions {
  getReservationLocations: () => Promise<ReservationLocation[] | undefined>
  getExperiences: () => Promise<Experience[] | undefined>
  goToExperienceDetailsPage: (experienceId: string) => void
}

export interface ExperiencesListStorage extends ExperiencesListData, ExperiencesListActions {}

const defaultExperiencesListStorage: ExperiencesListStorage = {
  getReservationLocationsStatus: RequestStatus.DEFAULT,
  getExperiencesStatus: RequestStatus.DEFAULT,
  breadcrumbsConfig: [],
  reservationLocations: [],
  experiences: [],
  fitToContentHeight: true,
  getReservationLocations: noop,
  getExperiences: noop,
  goToExperienceDetailsPage: noop,
}

const {withStorageProvider, useStorage} = createStorageProvider(defaultExperiencesListStorage)

const initExperiencesListStorage = (
  flowAPI: ControllerFlowAPI,
  controllerConfig: IWidgetControllerConfig,
  siteStructure: SiteStructure,
): ExperiencesListStorage => {
  return {
    ...defaultExperiencesListStorage,
    breadcrumbsConfig: getBreadcrumbsConfig(flowAPI, siteStructure, AppPage.ExperiencesList),
    regionalSettings: getRegionalSettings(flowAPI),
    getReservationLocations: wrapRequest(
      flowAPI,
      reservationLocationsService.getReservationLocations,
      'reservationLocations',
      'getReservationLocationsStatus',
    ),
    getExperiences: wrapRequest(
      flowAPI,
      experiencesService.getExperiences,
      'experiences',
      'getExperiencesStatus',
    ),
    goToExperienceDetailsPage: (experienceId: string) =>
      goToExperienceDetails(flowAPI, experienceId),
  }
}

const mockExperiencesListStorage = (
  flowAPI: ControllerFlowAPI,
  controllerConfig: IWidgetControllerConfig,
  siteStructure: SiteStructure,
): ExperiencesListStorage => {
  const initiatedStorage = initExperiencesListStorage(flowAPI, controllerConfig, siteStructure)

  return {
    ...initiatedStorage,
  }
}

export {
  initExperiencesListStorage,
  mockExperiencesListStorage,
  withStorageProvider as withExperiencesListStorageProvider,
  useStorage as useExperiencesListStorage,
}
